import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  content: {
    alignItems: 'center',
  },
  optInTitleText: {
    marginBottom: Theme.px(51),
    textAlign: 'center',
    width: Theme.px(428),
  },
});
